import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE, messagingQueryKeys } from '../config';
import { ChannelResponse, ChannelStatusEnum } from '../types/backend';
import { updateChannelInCache } from '../utils/updateChannelCache';

export type UnarchiveChannelDTO = {
  channelId: number;
  version: number;
};

const unarchiveChannel = async (
  data: UnarchiveChannelDTO
): Promise<ChannelResponse> => {
  const { channelId, version } = data;

  return axios.post(`${MESSAGING_API_BASE}/channels/${channelId}/unarchive`, {
    version,
  });
};

export const useUnarchiveChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UnarchiveChannelDTO) => unarchiveChannel(data),
    onSuccess: (_, variables) => {
      // Update channel status in cache immediately (optimistic update for current user)
      updateChannelInCache(queryClient, variables.channelId, {
        status: ChannelStatusEnum.ACTIVE,
      });
    },
  });
};
